import React from "react";

import {useInvestmentOfferAreas} from "../hooks/use_investment_offer_areas";
import {InvestmentOfferTile} from "./InvestmentOfferTile";
import {InvestmentOfferTiles} from "./InvestmentOfferTiles";

export const InvestmentOfferAreas = () => {
    const investmentOfferAreas = useInvestmentOfferAreas();

    return (
        <InvestmentOfferTiles title="Zainwestuj w apartament wakacyjny">
            {investmentOfferAreas.map((investmentOfferArea) => {
                return <InvestmentOfferTile key={investmentOfferArea.title} {...investmentOfferArea} ratioVariant="vertical" />;
            })}
        </InvestmentOfferTiles>
    );
};
import React from "react";

import {useInvestmentOfferAreas} from "../hooks/use_investment_offer_areas";
import {InvestmentOfferTile} from "./InvestmentOfferTile";
import {InvestmentOfferTiles} from "./InvestmentOfferTiles";

export const InvestmentOfferAreas = () => {
    const investmentOfferAreas = useInvestmentOfferAreas();

    return (
        <InvestmentOfferTiles title="Zainwestuj w apartament wakacyjny">
            {investmentOfferAreas.map((investmentOfferArea) => {
                return <InvestmentOfferTile key={investmentOfferArea.title} {...investmentOfferArea} ratioVariant="vertical" />;
            })}
        </InvestmentOfferTiles>
    );
};
